import ListingLibTableRow from 'framework-listing-lib/table/ListingLibTableRow';
import useRegisterNestedRow from 'framework-listing-lib/hooks/useRegisterNestedRow';
import { getContentAssociatedObjects } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function NestedContent({
  childCrmObject,
  parentCrmObject,
  tableRowProps
}) {
  const {
    isSelected
  } = useRegisterNestedRow({
    childCrmObject,
    parentCrmObject
  });
  return /*#__PURE__*/_jsx(ListingLibTableRow, Object.assign({}, tableRowProps, {
    parentCrmObject: parentCrmObject,
    crmObject: childCrmObject,
    isSelected: isSelected
  }));
}
export default function NestedContentRow({
  parentCrmObject,
  tableRowProps
}) {
  const childRows = getContentAssociatedObjects(parentCrmObject, 'OBJECT_TO_TRANSLATIONS');
  if (childRows.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: childRows.map(childCrmObject => /*#__PURE__*/_jsx(NestedContent, {
      childCrmObject: childCrmObject,
      parentCrmObject: parentCrmObject,
      tableRowProps: tableRowProps
    }, childCrmObject.objectId))
  });
}